import AppConfig from "@/_config/application-config";
import childRoutes from "@/apps/marginOpt/routes/index.js";
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const namespace = "marginOpt";
const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Margin Optimization",
  namespace,
  description: null,
  version: "1.1",
  icon: "mdi-alpha-r-circle-outline",
  parentRoute: "/marginOpt",
  accentColor: "red",
  childRoutes,
  defaultRoute: "segment",
  component: () =>
    import(
      /* webpackChunkName: "home-parent" */ "@/apps/marginOpt/Application.vue"
    ),
  settings: {
    //baseUrl: "https://localhost:44303/api/",
    // baseUrl: "https://as-marginopt-api.azurewebsites.net/api/",
    api_url: "https://as-marginopt-api.azurewebsites.net/api/",
    //api_url: "https://localhost:44303/api/",
    //client_id: "9c9d2381-a75d-462a-bee6-62656b755477",
    //scope: "api://9c9d2381-a75d-462a-bee6-62656b755477/Read.All",
    client_id: "228adde7-424d-4aa4-9410-cfe2a9e98436",
    scope: "api://228adde7-424d-4aa4-9410-cfe2a9e98436/ReadAll",
    authorize_url:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/authorize",
    token_url:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/token",
    logout_url:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080",
    powerbi_url:
      "https://app.powerbi.com/Redirect?action=OpenApp&appId=c21ef96a-393c-4be3-a1c3-02542b135ac5&ctid=fbe62081-06d8-481d-baa0-34149cfefa5f",
    commitment_url:
      "https://app.powerbi.com/links/8uobElkIpI?ctid=fbe62081-06d8-481d-baa0-34149cfefa5f&pbi_source=linkShare",
    expense_url:
      "https://app.powerbi.com/links/fMJr1LSC_7?ctid=fbe62081-06d8-481d-baa0-34149cfefa5f&pbi_source=linkShare",
    contactEmail: "Sebastian.Pick@lyondellbasell.com",
    redirect_uri: window.location.origin, //Gets the current
    autologin: true,
    debug: false,
    currentTime: null,
    currentTimeInterval: null,
    //azure_deployed: 1,
    // navigation: [
    //   {
    //     icon: "mdi-help",
    //     title: "Admin",
    //     route: "costcenter",
    //   },
    // ],
    navigation: [
      // {
      //   icon: "mdi-gauge",
      //   text: "Projects",
      //   link: "/marginOpt/projects",
      // },
      {
        icon: "mdi-segment",
        text: "Segment",
        link: "/marginOpt/segment",
      },
      {
        icon: "mdi-format-list-group",
        text: "Material Group",
        link: "/marginOpt/materialgroup",
      },
      {
        icon: "mdi-format-list-numbered-rtl",
        text: "Material Number",
        link: "/marginOpt/materialnumber",
      },
    ],
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor: {
      default: "red",
      storageMode: localStorage,
    },
    userInfo: {
      default: null,
      storageMode: localStorage,
    },
    isTrue: {
      default: true,
      storageMode: sessionStorage,
    },
  },
};

export default AppConfig.merge(appConfig);
